import React, {Component} from 'react'
import {Form, Select, Tag, notification, Empty, Spin} from 'antd'
import {getAllWenshuTopics, saveUserWenshuTopics} from "../../request";

export default class SysUserTopics extends Component {
    formRef = React.createRef();
    state = {
        allTopics: [],
        loading: false
    }

    componentDidMount() {
        this.loadAllTopics();
    }

    componentDidUpdate(prevProps) {
        if (this.props.userInfo.userId !== prevProps.userInfo.userId ||
            this.props.selectedTopicIds !== prevProps.selectedTopicIds) {
            this.resetForm();
        }
    }

    loadAllTopics = () => {
        this.setState({loading: true});
        getAllWenshuTopics({}).then(res => {
            this.setState({
                allTopics: res || [],
                loading: false
            });
        }).catch(() => {
            this.setState({loading: false});
        });
    }

    resetForm = () => {
        if (this.formRef.current) {
            this.formRef.current.setFieldsValue({topics: this.props.selectedTopicIds || []});
        }
    }

    handleChange = (changedValues, allValues) => {
        const {userInfo} = this.props;
        saveUserWenshuTopics({
            userId: userInfo.userId,
            topicIds: (allValues.topics || []).join(',')
        }).then(() => {
            notification.success({
                message: '操作成功',
            });
            this.props.onReload && this.props.onReload();
        });
    }

    render() {
        const {allTopics, loading} = this.state;
        const options = allTopics.map(t => ({
            label: t.topicName,
            value: t.topicId
        }));
        return (
            <Spin spinning={loading}>
                {
                    options.length > 0 ?
                        <Form
                            ref={this.formRef}
                            initialValues={{topics: this.props.selectedTopicIds}}
                            onValuesChange={this.handleChange}
                        >
                            <Form.Item name="topics">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    style={{width: '100%'}}
                                    showSearch
                                    placeholder="请选择"
                                    options={options}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    tagRender={(props) => {
                                        const {label, closable, onClose} = props;
                                        return (
                                            <Tag style={{margin: 5}} color={'blue'} closable={closable}
                                                 onClose={onClose}>{label}</Tag>
                                        )
                                    }}
                                />
                            </Form.Item>
                        </Form> :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                }
            </Spin>
        )
    }
}
